import React, { useState } from 'react';
import axios from 'axios';
import '../styles/TenderForm.css';
import Modal from './Modal';
import { FaCheckCircle } from 'react-icons/fa';
import logo from '../styles/logo.png'; // Ensure this file exists
import { Link } from 'react-router-dom';

// const API_BASE_URL = 'https://aiasapsolutions-production.up.railway.app';
const API_BASE_URL = 'http://localhost:5000';

const districts = [
  "Ariyalur", "Chengalpattu", "Chennai", "Coimbatore", "Cuddalore", "Dharmapuri",
  "Dindigul", "Erode", "Kallakurichi", "Kancheepuram", "Kanniyakumari", "Karur",
  "Krishnagiri", "Madurai", "Mayiladuthurai", "Nagapattinam", "Namakkal", "Nilgiris",
  "Perambalur", "Pudukkottai", "Ramanathapuram", "Ranipet", "Salem", "Sivaganga",
  "Tenkasi", "Thanjavur", "Theni", "Thoothukudi", "Tiruchirappalli", "Tirunelveli",
  "Tirupathur", "Tiruppur", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Vellore",
  "Viluppuram", "Virudhunagar"
];

function TenderForm() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    whatsapp: '+91', // Default value with India extension code
    billingAddress: '',
    preferences: [],
    otp: '',
  });
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'
  const [showModal, setShowModal] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'preferences') {
      const options = Array.from(e.target.selectedOptions, (option) => option.value);
      if (options.length <= 3) {
        setForm({ ...form, preferences: options });
      } else {
        alert('You can select up to 3 districts only.');
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    let newPreferences = [...form.preferences];
    if (checked) {
      if (newPreferences.length < 3) {
        newPreferences.push(value);
      } else {
        alert('You can select up to 3 districts only.');
        e.target.checked = false;
      }
    } else {
      newPreferences = newPreferences.filter((pref) => pref !== value);
    }
    setForm({ ...form, preferences: newPreferences });
  };

  const handleSendOtp = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/send-otp`, { whatsappNumber: form.whatsapp });
      if (response.data.success) {
        setMessage('OTP sent successfully!');
        setMessageType('success');
        setOtpSent(true);
      } else {
        setMessage(`Failed to send OTP: ${response.data.message}`);
        setMessageType('error');
      }
      setShowModal(true);
    } catch (error) {
      setMessage(`Failed to send OTP: ${error.message}`);
      setMessageType('error');
      setShowModal(true);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/verify-otp`, { whatsappNumber: form.whatsapp, otp: form.otp });
      if (response.data.success) {
        setMessage('OTP verified successfully!');
        setMessageType('success');
        setOtpVerified(true);
      } else {
        setMessage(`Failed to verify OTP: ${response.data.message}`);
        setMessageType('error');
        resetForm();
      }
      setShowModal(true);
    } catch (error) {
      setMessage(`Failed to verify OTP: ${error.message}`);
      setMessageType('error');
      resetForm();
      setShowModal(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otpVerified) {
      try {
        console.log('Submitting form data:', form); // Debugging: Log form data
        const response = await axios.post(`${API_BASE_URL}/subscribe`, {
          name: form.name,
          email: form.email,
          whatsapp: form.whatsapp,
          billingAddress: form.billingAddress,
          preferences: form.preferences,
        });
        console.log('Response from server:', response.data); // Debugging: Log server response
        if (response.data.success) {
          setMessage('Subscription successful!');
          setMessageType('success');
        } else {
          setMessage(`Subscription failed: ${response.data.message}`);
          setMessageType('error');
        }
        setShowModal(true);
      } catch (error) {
        console.error('Error during subscription:', error); // Debugging: Log error
        if (error.response) {
          console.error('Error response data:', error.response.data); // Log response data
          console.error('Error response status:', error.response.status); // Log response status
          console.error('Error response headers:', error.response.headers); // Log response headers
        }
        setMessage(`Subscription failed: ${error.message}`);
        setMessageType('error');
        setShowModal(true);
      }
    } else {
      setMessage('Please verify the OTP first.');
      setMessageType('error');
      setShowModal(true);
    }
  };

  const resetForm = () => {
    setForm({
      name: '',
      email: '',
      whatsapp: '+91', // Reset to default value with India extension code
      billingAddress: '',
      preferences: [],
      otp: '',
    });
    setOtpSent(false);
    setOtpVerified(false);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="tender-container">
      <h1>Subscribe to Tender Updates</h1>
      <Modal show={showModal} onClose={closeModal} message={message} messageType={messageType} />
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name</label>
          <input type="text" className="form-control" name="name" onChange={handleChange} value={form.name} required />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input type="email" className="form-control" name="email" onChange={handleChange} value={form.email} required />
        </div>
        <div className="form-group">
          <label>WhatsApp Contact</label>
          <input type="text" className="form-control" name="whatsapp" onChange={handleChange} value={form.whatsapp} required disabled={otpVerified} />
        </div>
        {otpSent && (
          <div className="form-group">
            <label>Enter OTP</label>
            <input type="text" className="otp-input" name="otp" maxLength="6" onChange={handleChange} value={form.otp} required />
            <button type="button" className="custom-verify-btn" onClick={handleVerifyOtp}>
              Verify OTP
            </button>
          </div>
        )}
        {otpVerified && (
          <>
            <div className="form-group">
              <label>Billing Address</label>
              <textarea className="form-control" name="billingAddress" onChange={handleChange} value={form.billingAddress} required></textarea>
            </div>
            <div className="form-group">
              <label>Select your preferred district</label>
              <div className="districts-container">
                {districts.map((district) => (
                  <div key={district} className="district-item">
                    <input
                      type="checkbox"
                      name="preferences"
                      value={district}
                      checked={form.preferences.includes(district)}
                      onChange={handleCheckboxChange}
                    />
                    <label>{district}</label>
                  </div>
                ))}
              </div>
            </div>
            <button type="submit" className="btn-sec">
              Subscribe
            </button>
          </>
        )}
        {!otpSent && (
          <button type="button" className="btn-sec" onClick={handleSendOtp}>
            Send OTP
          </button>
        )}
      </form>
    </div>
  );
}

export default TenderForm;